// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQ_faq__B2hgV {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.FAQ_inner__9ICKe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 18px;
  padding: 16px;
  background: #fff;
  margin: 24px 0;
  max-width: 800px;
  width: 100%;
  background: #2b0010;
  box-shadow: 0px 3px 16px 0px rgb(107 18 63);
  border: 2px solid #e868a8;
  border-radius: 20px;
}
.FAQ_title__rcgnw {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #fff;
}
.FAQ_title__rcgnw img {
}
.FAQ_title__rcgnw p {
  color: #101010;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.FAQ_items__V838u {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.FAQ_item__SlEmn {
  border-radius: 12px;
  border: 1px solid #291219;
  background: #4e1d38;
  padding: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
.FAQ_question__yI1GC {
  color: #ffffff;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}
.FAQ_answer__6iR3Z {
  width: 100%;
}
.FAQ_answer__6iR3Z span {
  color: #ffffff;
  text-align: right;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.FAQ_answer__6iR3Z p {
  color: #ffffff;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.FAQ_line__Kc9OD {
  width: 100%;
  height: 1px;
  background: #a65b85;
  margin: 12px 0;
}
@media screen and (min-width: 1000px) {
  .FAQ_answer__6iR3Z p {
    font-size: 13px;
  }
  .FAQ_answer__6iR3Z span {
    font-size: 13px;
  }
  .FAQ_question__yI1GC {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FAQ/FAQ.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;AACA;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".faq {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 18px;\n  padding: 16px;\n  background: #fff;\n  margin: 24px 0;\n  max-width: 800px;\n  width: 100%;\n  background: #2b0010;\n  box-shadow: 0px 3px 16px 0px rgb(107 18 63);\n  border: 2px solid #e868a8;\n  border-radius: 20px;\n}\n.title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  color: #fff;\n}\n.title img {\n}\n.title p {\n  color: #101010;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.items {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n.item {\n  border-radius: 12px;\n  border: 1px solid #291219;\n  background: #4e1d38;\n  padding: 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n}\n.question {\n  color: #ffffff;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  cursor: pointer;\n}\n.answer {\n  width: 100%;\n}\n.answer span {\n  color: #ffffff;\n  text-align: right;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.answer p {\n  color: #ffffff;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.line {\n  width: 100%;\n  height: 1px;\n  background: #a65b85;\n  margin: 12px 0;\n}\n@media screen and (min-width: 1000px) {\n  .answer p {\n    font-size: 13px;\n  }\n  .answer span {\n    font-size: 13px;\n  }\n  .question {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faq": `FAQ_faq__B2hgV`,
	"inner": `FAQ_inner__9ICKe`,
	"title": `FAQ_title__rcgnw`,
	"items": `FAQ_items__V838u`,
	"item": `FAQ_item__SlEmn`,
	"question": `FAQ_question__yI1GC`,
	"answer": `FAQ_answer__6iR3Z`,
	"line": `FAQ_line__Kc9OD`
};
export default ___CSS_LOADER_EXPORT___;
